import React from 'react';
import PropTypes from 'prop-types';
import { FlowContext } from 'moet-core';

import TopBar from './TopBar';

export const ContextWrappedTopBar = () => {
  return <FlowContext.Consumer>{props => <TopBar {...props} />}</FlowContext.Consumer>;
};

ContextWrappedTopBar.propTypes = {
  ...TopBar.propTypes,
  productOptions: PropTypes.array,
};

export default ContextWrappedTopBar;
